<template>
  <el-dialog title="编辑业务板块" :visible.sync="currentValue" width="440px" custom-class="business-unit-dialog" top="0" append-to-body @open="open" @close="close">
    <div class="content">
      <div class="content-box" ref="content-box">
        <div class="item" v-if="isAdd">
          <el-input placeholder="请输入业务板块" style="width: 320px;" ref="addInput" v-model="addTitle" @blur="addInputBlur" @change="addInputChange" clearable></el-input>
        </div>
        <div class="item bgActive" v-for="(item, index) in businessData" :key="item.id" @click="editItem(item)">
          <toolTip class="title" v-if="!item.isEdit" :title="item.name" maxWidth="auto">
            <span>{{item.name}}</span>
          </toolTip>
          <el-input v-else placeholder="请输入业务板块" style="width: 320px;" :ref="item.inputRef" @blur="inputBlur(item)" v-model="item.name" @change="inputChange(item)" clearable></el-input>
          <span class="text-red" @click.stop="del(item, index)">删除</span>
        </div>
      </div>
      <div class="btn">
        <span class="text-blue"  @click="add"><i class="icon iconfont iconicon_new_subproject"></i>添加业务板块</span>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import vuedraggable from 'vuedraggable'
import Api from '@/services/api/systemSetting/systemSetting'
export default {
  props:['value'],
  components: {
    vuedraggable
  },
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
  },
  data() {
    return {
      businessData: [],
      isAdd: false,
      addTitle: '',
      copyTitle: '',
      isChange: false
    }
  },
  methods: {
    open() {
      this.isChange = false
      this.fetchBusinessData()
    },
    async fetchBusinessData() {
      // 获取业务板块数据
      await Api.getProjectFolderList().then(res => {
        this.businessData = res.data.map((item) => {
          item.id = item.project_list_id
          item.name = item.title
          item.isEdit = false
          item.inputRef = item.id + '_input'
          return item;
        })
      })
    },
    editItem(item) {
      this.copyTitle = item.name
      item.isEdit = true
      this.$nextTick(() => {
        this.$refs[item.inputRef][0].focus()
      })
    },
    inputBlur(item) {
      item.isEdit = false
    },
    inputChange(item) {
      if(!item.name) {
        item.name = this.copyTitle
        return
      }
      this.isChange = true
      Api.updateProjectFolder({
        'project_list_id': item.id,
        'title': item.name
      })
    },
    async del(item, index) {
      await this.$wfAlert('warning', `确认删除此业务？`)
      // 删除业务线
      this.isChange = true
      await Api.deleteProjectFolder({
        project_list_id: item.project_list_id
      })
      this.businessData.splice(index, 1)
    },
    add() {
      this.$refs['content-box'].scrollTo = 0
      this.addTitle = ''
      this.isAdd = true
      this.$nextTick(() => {
        this.$refs['addInput'].focus()
      })
    },
    addInputBlur() {
      this.isAdd = false
    },
    async addInputChange() {
      if(!this.addTitle) return
      this.isChange = true
      await Api.addProjectFolder({
        'title': this.addTitle,
        'icon': '1',
        'icon_color': '1'  //必填
      })
      this.fetchBusinessData()
    },
    close() {
      if(this.isChange) {
        this.$emit('change')
      }
    }
  }
}
</script>
<style lang="scss">
.business-unit-dialog {
  top: 50%;
  transform: translate(0, -50%);
  .el-dialog__header {
    padding: 15px 24px;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(32, 32, 32, 0.08);
  }
  .el-dialog__headerbtn {
    top: 15px;
  }
  .el-dialog__body {
    padding: 0;
  }
  .content {
    height: 560px;
    display: flex;
    flex-direction: column;
  }
  .content-box {
    height: 0;
    flex: 1;
    overflow-x: hidden;
    overflow-y: overlay;
    padding: 8px 0;
    .item {
      height: 48px;
      padding: 0 24px;
      padding-left: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &:hover {
        .text-red {
          visibility: visible;
        }
      }
    }
    .title {
      width: 0;
      flex: 1;
      padding-left: 16px;
    }
    .text-red {
      visibility: hidden;
    }
  }
  .btn {
    height: 54px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(32, 32, 32, 0.8);
    font-size: 14px;
    border-top: 1px solid rgba(32, 32, 32, 0.08);
    box-sizing: border-box;
    i {
      margin-right: 8px;
      font-size: 14px;
    }
  }
}
</style>
